import { ReactNode, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Icon, UnknownFunction } from '@eon-home/react-library';

import { useTenantData } from '@store/selectors';
import { composeClassName } from '@tools/utils';
import { EXTERNAL_LINK_PROPS } from '@tools/constants';

import './index.scss';

import MailIcon from '@assets/icons/misc/mail.svg';

export interface GenericErrorProps {
    header?: ReactNode;
    onRetry?: UnknownFunction;
    centerText?: boolean;
}

export const GenericError: FC<Readonly<GenericErrorProps>> = ({
    header,
    onRetry,
    centerText = false,
}: GenericErrorProps) => {
    const { t } = useTranslation();
    const email = useTenantData('emailContact');

    return (
        <>
            {header}

            <div
                className={composeClassName('c-generic-error', [
                    centerText ? 'center' : '',
                ])}
            >
                <h1>{t('Sorry, something went wrong.')}</h1>

                <p>
                    {t(
                        'Please try again later. If your problem persists please contact our support.',
                    )}
                </p>

                {email && (
                    <a href={`mailto:${email}`} {...EXTERNAL_LINK_PROPS}>
                        <Icon src={MailIcon} />
                        {email}
                    </a>
                )}

                {typeof onRetry === 'function' && (
                    <Button small type="button" onClick={onRetry}>
                        {t('Retry')}
                    </Button>
                )}
            </div>
        </>
    );
};

export default GenericError;
